import { render, staticRenderFns } from "./DeleteOne.vue?vue&type=template&id=334f7a68&lang=pug"
import script from "./DeleteOne.vue?vue&type=script&lang=js"
export * from "./DeleteOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports